import { StyleSheet, View, ViewProps } from 'react-native'
import { useTranslation } from 'react-i18next'
import { Color, Radius, Spacing } from 'zens-storybook'
import { ApiError, Draft, ProfileDataPassword, useProfile, useProfileMutation, useStore } from 'zens-store'
import { useState } from 'react'
import { useRouter, useParams, useNumberParams } from 'zens-router'
import { PageHeader, ProfilePassword } from '@dms/component'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    margin: Spacing.L,
    padding: Spacing.L,
    backgroundColor: Color.simplyWhite,
    borderRadius: Radius.M,
  },
})

interface Props extends ViewProps {}

const ProfilePasswordScreen = (props: Props) => {
  const { style, ...otherProps } = props
  const [errors, setErrors] = useState<Record<string, string>>()
  const [{ next }] = useParams()
  const [{ companyId }] = useNumberParams()
  const router = useRouter()
  const { message } = useStore()
  const profile = useProfile()
  const mutation = useProfileMutation()
  const { t } = useTranslation()

  const save = async (draft: Draft<ProfileDataPassword>) => {
    try {
      setErrors({})
      await mutation.updatePassword(draft)
      message.add({
        message: t('Password was updated successfully'),
        status: 'success',
      })
    } catch (error) {
      const { message: errorMessage, fields } = error as ApiError
      console.debug(`PROFILE: Profile failed: ${errorMessage}`)
      if (fields) {
        setErrors(fields)
      } else {
        message.add({
          message: `${t('Password could not be updated')}. ${errorMessage}`,
          status: 'error',
        })
      }
      return
    }
    router.push({ pathname: `/profile`, params: { companyId, next } })
  }

  const cancel = async () => {
    router.push({ pathname: `/profile`, params: { companyId, next } })
  }

  return (
    <View style={[styles.container, style]} {...otherProps}>
      <PageHeader title={t('Change password')} />
      <View style={styles.content}>
        {profile.data && <ProfilePassword data={profile.data?.data} onSave={save} onCancel={cancel} errors={errors} />}
      </View>
    </View>
  )
}

export default ProfilePasswordScreen
